import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import ProjectSubItems from "../components/Project/ProjectSubItems";
import ProjectTextField from "../components/Project/ProjectTextField";
import ProjectSelectField from "../components/Project/ProjectSelectField";
import ProjectBreadcrumb from "../components/Project/ProjectBreadcrumb";
import queryString from 'query-string';
import Button from '@material-ui/core/Button';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import {
    attachProjectSetting, createChildProjectSetting,
    createProjectSetting,
    deleteProjectSetting, detachProjectSetting,
    getProjectSettings,
    saveProjectSetting
} from '../api'
import Layout from "../components/Simple/Layout";
import TextEditor from "../components/Simple/TextEditor";
import DashboardSegmentBehaviourTable from "../components/Dashboard/DashboardSegmentBehaviourTable";
import DashboardSegmentCreator from "../components/Dashboard/DashboardSegmentCreator";
import SearchFormDates from "../components/Filters/TableFilters/SearchFormDates";
import moment from 'moment'

moment.locale('fi-fi')

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        maxWidth: 2000,
        margin: 'auto',
    },
    moreButton: {
        background: 'white',
        minWidth: 0,
        fontSize: '1.6rem',
    },
    leftIcon: {
        marginRight: 8,
    },
    button: {
        marginBottom: 6,
        marginLeft: 16,
    },
    title: {
        fontWeight: 300,
        display: 'inline-block',
    }
});

class AdminDashboard extends PureComponent {
    state = {
        isLoading: true,
        segmentCreatorVisible: false,
        from: moment().subtract(6, 'day'),
        to: moment(),
        segmentBehaviourData: null,
        segments: [{name: 'Kaikki'}],
    }

    componentDidMount() {
        this.refresh()
        this.props.setPageTitle('Hallintapaneeli')
    }

    refresh = () => {
        const {from, to, segments} = this.state;

        const requestSegments = segments.length > 0 ? segments : [{name: 'Kaikki'}];

        const updateState = response => {
            const data = response.data

            const newState = {
                segmentBehaviourData: data.segmentBehaviour,
                isLoading: false,
            };

            this.setState(newState)
        }

        this.setState({isLoading: true, segmentBehaviourData: null}, () => {
            this.props.initSrc(requestSegments, from, to).then(updateState).catch((err) => {
                alert(err)
            })
        });
    }

    toggleSegmentCreator = () => {
        this.setState({segmentCreatorVisible: !this.state.segmentCreatorVisible})
    }

    onFilterDate = (filter) => {
        const dateString = (filter.from ? filter.from.format('YYYY-MM-DD') : '') + ' - ' + (filter.to ? filter.to.format('YYYY-MM-DD') : '')
        this.setState({from: filter.from, to: filter.to}, () => this.refresh())
    }

    createSegment = (name, filters) => {
        this.setState({
            segmentCreatorVisible: false,
            segments: [...this.state.segments, {
                name: name,
                filters: filters
            }]
        }, () => this.refresh())
    }

    removeSegment = (key) => {
        this.state.segments.splice(key, 1)

        this.setState({segments: this.state.segments}, () => this.refresh())
    }


    render() {
        const {classes} = this.props
        const {isLoading, segmentCreatorVisible, segmentBehaviourData, from, to} = this.state;

        return (
            <div className={classes.root}>
                <div className={classes.container}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant={'h5'} className={classes.title}>Käyttäytyminen</Typography>
                            {!segmentCreatorVisible &&
                            <Button color="primary" className={classes.button} size={'small'}
                                    onClick={this.toggleSegmentCreator}>
                                <FontAwesomeIcon size={'sm'} icon={['fal', 'plus']} className={classes.leftIcon}/> Lisää
                                segmentti
                            </Button>
                            }
                        </Grid>
                        <Grid item xs={12} sm={6} align={'end'} style={{marginTop: -5, marginBottom: 7}}>
                            <SearchFormDates onFilter={this.onFilterDate} from={this.state.from}
                                             to={this.state.to}/>
                        </Grid>
                        {segmentCreatorVisible &&
                        <DashboardSegmentCreator toggle={this.toggleSegmentCreator} from={from} to={to}
                                                 create={this.createSegment}/>
                        }
                        <Grid item xs={12} md={12}>
                            <DashboardSegmentBehaviourTable data={segmentBehaviourData} isLoading={isLoading}
                                                            removeSegment={this.removeSegment}/>
                            <div className="status-description-wrapper" style={{marginTop: 12}}><span
                                className="status-description"><span
                                className="status-icon status-10"
                                title="Allekirjoituksessa"></span> Vahvistettu</span><span
                                className="status-description"><span className="status-icon status-8"
                                                                     title="Tarjous hyväksytty"></span> Tarjous hyväksytty</span><span
                                className="status-description"><span className="status-icon status-7"
                                                                     title="Tarjous tehty"></span> Tarjous tehty</span><span
                                className="status-description"><span className="status-icon status-5"
                                                                     title="Odottaa tarjousta"></span> Odottaa tarjousta</span><span
                                className="status-description"><span className="status-icon status-2"
                                                                     title="Virhe"></span> Virhe</span><span
                                className="status-description"><span className="status-icon status-1"
                                                                     title="Hylätty"></span> Hylätty</span>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}

AdminDashboard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminDashboard);
